import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { endpoints } from '@rossum/api-client';
import { useApiClient } from '../../lib/apiClient';
import { throwError } from '../../redux/modules/messages/actions';
import { QUERY_KEY_USERS } from './useUsers';

export const useDeleteUser = () => {
  const dispatch = useDispatch();
  const api = useApiClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId }: { userId: number; onSuccess: () => void }) =>
      api.request(endpoints.users.delete(userId)),

    onSuccess: (_, { onSuccess }) => {
      onSuccess();
      queryClient.invalidateQueries({
        queryKey: [QUERY_KEY_USERS],
      });
    },

    onError: () => {
      dispatch(throwError('userDeletedError'));
    },
  });
};
